<template>
    <el-dialog :title="form.id > 0 ? '编辑报价' : '新增报价'" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="报价ID：" :label-width="formLabelWidth" v-if="form.id > 0">
                {{form.id}}
            </el-form-item>
            <el-form-item label="业务员：" prop="user_id" :label-width="formLabelWidth">
                <UserSelect :uid="parseInt(this.form.user_id)" @change="userHandleChange($event)"></UserSelect>
            </el-form-item>
            <el-form-item label="客户名称：" prop="customer_id" :label-width="formLabelWidth">
                <CustomerSelect 
                    :scenary="scenary" 
                    :onlyShow="true" 
                    :customerIdss="form.customer_name" 
                    v-model="form.customer_id" 
                    >
                </CustomerSelect>
            </el-form-item>
            <el-form-item label="合作产品：" prop="products" :label-width="formLabelWidth">
                <ProductType v-model="form.products" :productCheckedIds="form.products" @change="productsChange($event)"></ProductType>
            </el-form-item>
            <el-form-item label="合作方式：" prop="mode" size="small" :label-width="formLabelWidth">
                <el-select v-model="form.mode" placeholder="请选择合作方式">
                    <el-option label="额度版" value="1"></el-option>
                    <el-option label="半年" value="2"></el-option>
                    <el-option label="一年" value="3"></el-option>
                    <el-option label="两年" value="4"></el-option>
                    <el-option label="三年" value="5"></el-option>
                    <el-option label="四年" value="6"></el-option>
                    <el-option label="五年" value="7"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="报价：" prop="price" :label-width="formLabelWidth">
                <el-input v-model="form.price" type="number" autocomplete="off" size="small" style="width: 150px" placeholder="请输入报价"></el-input>
            </el-form-item>
            <el-form-item label="客户联系人：" prop="contact_id" :label-width="formLabelWidth">
                <el-col class="line" :span="8">
                    <el-select size="small" v-model="form.contact_name" placeholder="请选择" @change="selectCustomerSign">
                        <el-option
                            v-for="item in customer_contracts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id" v-show="form.customer_id == item.customer_id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col class="inline-item" :span="8" style="margin-left: 10px">
                    联系电话：<span>{{(form.customer_mobile) ? form.customer_mobile : '无'}}</span>
                </el-col>
            </el-form-item>
            <el-form-item label="学段选择：" prop="stage" :label-width="formLabelWidth">
                <el-checkbox-group v-model="form.stage">
                    <el-checkbox label="1">小学</el-checkbox>
                    <el-checkbox label="2">初中</el-checkbox>
                    <el-checkbox label="3">高中</el-checkbox>
                    <el-checkbox label="4">中职</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="学校规模：" :label-width="formLabelWidth">
                <el-col class="inline" :span="10">
                    <el-form-item label="班级数：" class="inline-item" prop="class_num">
                        <el-input type="number" size="small" style="width: 130px" v-model="form.class_num" placeholder="请输入班级数"></el-input>
                    </el-form-item>
                </el-col>
                <el-col class="inline" :span="10">
                    <el-form-item label="教师数：" class="inline-item" prop="teacher_num">
                        <el-input type="number" size="small" style="width: 130px" v-model="form.teacher_num" placeholder="请输入教师数"></el-input>
                    </el-form-item>
                </el-col>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('form')" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>
<style scoped>

</style>
<script>
    import CustomerQuote from "~/services/CustomerQuote";
    import ProductType from "~/widgets//ProductType.vue";
    import UserSelect from "~/widgets/UserSelect.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    export default {
        name: "addQuote",

        components: {
            ProductType,
            UserSelect,
            CustomerSelect,
        },

        props: {
            customer: {
                type: Object,
                required: true
            },

            model: {
                type: Object,
            },
        },

        data() {
            return {
                formLabelWidth: '120px',
                loading: false,
                form: {
                    user_id: '',
                    customer_id: '',
                    customer_name: '',
                    products: [],
                    mode: '',
                    price: '',
                    contact_id: '',
                    stage: [],
                    class_num: '',
                    teacher_num: '',
                },
                dialogFormVisible: true,
                scenary: 'create_order_use',
                customer_contracts: [],
                rules: {
                    user_id: [
                        {required: true, message: '请选择业务员', trigger: 'blur'},
                    ],
                    products: [
                        {required: true, message: '请选择产品', trigger: 'blur'}
                    ],
                    mode: [
                        {required: true, message: '请选择合作方式', trigger: 'blur'},
                    ],
                    price: [
                        {required: true, message: '请输入报价', trigger: 'blur'},
                    ],
                    contact_id: [
                        {required: true, message: '请选择联系人', trigger: 'blur'},
                    ],
                    stage: [
                        {required: true, message: '请选择学段', trigger: 'blur'},
                    ],
                    class_num: [
                        {required: true, message: '请输入班级数', trigger: 'blur'},
                    ],
                    teacher_num: [
                        {required: true, message: '请输入教师数', trigger: 'blur'},
                    ]
                },
            };
        },

        mounted() {},

        created: function () {
            if(this.model && this.model.id > 0){
                this.form = _.clone(this.model);
            }else{
                this.form.user_id = this.$store.getters.userId;
                this.form.customer_id = this.customer.id;
                this.form.customer_name = this.customer.name;
                this.form.class_num = this.customer.class_num;
                this.form.teacher_num = this.customer.teacher_num;
                this.form.stage = this.customer.periods.map(String);
            }
            this.customer_contracts = this.customer.contacts;
        },

        methods: {
            //业务员姓名远程搜索组件赋值
            userHandleChange(object) {
                this.form.user_id = object.label;
                this.form.user_name = object.value;
            },

            productsChange(val){
                this.form.products = val;
            },
            // //客户名称远程搜索组件赋值
            // CustomerHandleChange(object) {
            //     global.customer_id = object.label;
            //     this.customer_id = object.label;
            //     if (typeof this.customer_id == "undefined") return false;
            //     this.form.customer_id = object.label;
            // },

            //客户签约人
            selectCustomerSign($event) {
                let contact = this.customer_contracts.find(item => {
                    if (item.id == $event) {
                        return item;
                    }
                });
                if (contact) {
                    this.form.contact_id = contact.id;
                    this.form.contact_name = contact.name;
                    this.form.customer_sign_man = contact.name;
                    this.form.customer_mobile = this.form.contact_mobile =  contact.mobile || contact.phone_number;
                }
            },

            /**@description 提交处理 */
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        let quote;
                        if(this.form.id > 0){
                            quote = CustomerQuote.update(this.form);
                        }else{
                            quote = CustomerQuote.create(this.form);
                        }
                        quote.then(res => {
                            if (res && res.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.dialogFormVisible = false;
                                this.$emit("change", this.form); 
                            }
                            this.loading = false;
                        }).catch(err => {
                            console.error(err);
                            this.$message({
                                message: res.msg,
                                type: 'error'
                            });
                            this.loading = false;
                        });
                    } else {
                        console.log('error submit!!');
                    }
                });
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/views/customer/dialog/addQuote.vue